export enum RoleTypeEnum {
  ADMIN = 'ADMIN',
  MAKER = 'MAKER',
  CHECKER = 'CHECKER',
  APPROVAL = 'APPROVAL',
  CAD_ADMIN = 'CAD_ADMIN',
  CAD_SUPERVISOR = 'CAD_SUPERVISOR',
  LEGAL = 'LEGAL',
  ACCESSOR_MAKER = 'ACCESSOR_MAKER',
  ACCESSOR_CHECKER = 'ACCESSOR_CHECKER',
  EXTERNAL_ACCESSOR = 'EXTERNAL_ACCESSOR',
  EXTERNAL_LAWYER = 'EXTERNAL_LAWYER',
  INTERNAL_LAWYER = 'INTERNAL_LAWYER',
  PRE_PROCESSING_OFFICER = 'PRE_PROCESSING_OFFICER',
  CREDIT_ANALYST = 'CREDIT_ANALYST',
  LEAD_CREDIT_ANALYST = 'LEAD_CREDIT_ANALYST',
  COMMITTEE = 'COMMITTEE',
  CAD_HOD = 'CAD_HOD',
  CREDIT_ADMIN = 'CREDIT_ADMIN',
  LEGAL_HEAD = 'LEGAL_HEAD',
  CAD_LEGAL = 'CAD_LEGAL',
  CRC = 'CRC',
  COPS = 'COPS',
  DESK_OFFICER = 'DESK_OFFICER',
  RISK_CONTROLLER = 'RISK_CONTROLLER',
  VALUATOR_ADMIN = 'VALUATOR_ADMIN',
  RISK_MAKER = 'RISK_MAKER',
  RISK_CHECKER = 'RISK_CHECKER',
  CSU = 'CSU',
  LOAN_RECOVERY = 'LOAN_RECOVERY'
}

export namespace RoleTypeEnum {
  export function values() {
    return Object.keys(RoleTypeEnum).filter(
      (type) => isNaN(type as any) && type !== 'values' && type !== 'enumObject' && type !== 'getKeyByEnumValue'
    );
  }

  export function enumObject() {
    const enums: {
      key: string;
      value: any;
    }[] = [];
    values().forEach((elem) => {
      enums.push({
        key: elem,
        value: RoleTypeEnum[elem as keyof typeof RoleTypeEnum]
      });
    });
    return enums;
  }

  export function getKeyByEnumValue(enumValue: any) {
    return Object.keys(RoleTypeEnum).find(key => RoleTypeEnum[key as keyof typeof RoleTypeEnum] === enumValue);
  }
}
